export default class PruebasFuncionales {
    switch1=false
    switch2=false
    switch3=false
    switch4=false
    switch5=false
    switch6=false
    switch7=false
    switch8=false
    switch9=false
    switch10=false
    switch11=false
    switch12=false
    switch13=false
    switch14=false
    switch15=false
    switch16=false
    switch17=false
    switch18=false
    switch19=false
    switch20=false
    switch21=false
    switch22=false
    switch23=false
    switch24=false
    switch25=false
    switch26=false
    switch27=false
    switch28=false
    switch29=false
    switch30=false
    switch31=false
    switch32=false
    switch33=false
    informacionLaboral=[
        {valor:"", descripcion:"", tipo:20 ,label:"a. Datos de filiación:", bold:false},
        {valor:"", descripcion:"", tipo:21 ,label:"      C.I.: 1721930442", bold:false},
        {valor:"", descripcion:"", tipo:22 ,label:"      Edad: 32", bold:false},
        {valor:"", descripcion:"", tipo:23 ,label:"      Apellidos y nombres: LOPEZ CRISTIAN", bold:false},
        {valor:"", descripcion:"", tipo:24 ,label:"      Empresa: PRIVADOS", bold:false},
        {valor:"", descripcion:"", tipo:25 ,label:"      Puesto de trabajo: PRIVADO", bold:false},
        ]
    obs1=""
    obs2=""
    obs3=""
    obs4=""
    obs5=""
    obs6=""
    obs7=""
    obs8=""
    obs9=""
    obs10=""
    obs11=""
    obs12=""
    obs13=""
    obs14=""
}


// WEBPACK FOOTER //
// ./src/model/PruebasFuncionales.js